var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CommentBox as OriginalCommentBox } from './CommentBox';
import CuppingDescriptors from './CuppingDescriptors';
import CuppingDescriptorsChart from './CuppingDescriptorsChart';
import CommentsSummaryUsers from './CommentsSummaryUsers';
import { Divider, Stack } from '@mui/material';
var CommentBox = styled(OriginalCommentBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 24px;\n  border: none;\n  background-color: #fff;\n  box-shadow: 0 12px 24px rgb(145 158 171 / 12%);\n  position: relative;\n"], ["\n  padding: 24px;\n  border: none;\n  background-color: #fff;\n  box-shadow: 0 12px 24px rgb(145 158 171 / 12%);\n  position: relative;\n"])));
var Score = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 36px;\n  line-height: 40px;\n  font-weight: bold;\n  margin-bottom: 8px;\n\n  div {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: normal;\n  }\n"], ["\n  font-size: 36px;\n  line-height: 40px;\n  font-weight: bold;\n  margin-bottom: 8px;\n\n  div {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: normal;\n  }\n"])));
var CommentsSummary = function (_a) {
    var comments = _a.comments, scoreAverage = _a.scoreAverage, descriptorSummary = _a.descriptorSummary;
    var t = useTranslation().t;
    var descriptors = React.useMemo(function () { return Object.keys(descriptorSummary); }, [descriptorSummary]);
    var users = React.useMemo(function () { return comments.map(function (_a) {
        var user = _a.user;
        return user;
    }); }, [comments]);
    return (React.createElement(CommentBox, { className: "summary" },
        scoreAverage && (React.createElement(Score, { className: "score" },
            scoreAverage,
            React.createElement("div", null, t('params.offer.cuppingScoreAverage')))),
        descriptors.length > 0 && (React.createElement(Stack, { spacing: 3 },
            React.createElement(CuppingDescriptorsChart, { descriptors: descriptors }),
            React.createElement(CuppingDescriptors, { descriptors: descriptorSummary }))),
        scoreAverage ||
            (descriptors.length > 0 && (React.createElement(Divider, { sx: { borderStyle: 'dashed', my: 2 } }))),
        React.createElement(CommentsSummaryUsers, { users: users })));
};
export default CommentsSummary;
var templateObject_1, templateObject_2;
